import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import SelectMemberList from '../SelectMemberList';
import SelectCompanyComboBox from '../../../../../components/SelectCompanyComboBox';
import dataModel from '../../../../../models/DataModel';
import './CompanyMembers.scss';
import LoadingDots from '../../../../../components/LoadingDots';

export class CompanyMembers extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      menu: null,
      editing: false,
    };
    this.market_id = null;

    this.createSelectedMemberList = this.createSelectedMemberList.bind(this);
  }

  handleLoadMarket() {
    const { project } = this.props;
    this.market_id = project.market_id;
    this.setState({ loadingMarkets: true }, () => {
      dataModel.marketsDAO.getMarket(project.market_id, project.company_id, {
        recordDescriptor: {
          market:
          {
            market_users:
              // TODO: show market uses special serialization and as such
              // does not handle profile_image (which is not a true attribute)
              // may need to handle that eventually (or figure out why it is
              // not)
              //{ user: { additionalFields: ["profile_image"]} },
              { user: {} },
            market_vendor_users:
            {
              //vendor_user: { additionalFields: ["profile_image"], companies: {}},
              vendor_user: { companies: {} },
            },
            // vendor_users: { additionalFields: ["profile_image"], companies: {}},
            vendor_users: { companies: {} },
          },

        },
      }).then(market => {
        this.setState({ loadingMarkets: false });
        if (market) {
          let users = [];
          if (market.market_users) {
            market.market_users.forEach(market_user => {
              if (market_user.user && market_user.user.id && !market_user.user.suspended) {
                users.push(market_user.user);
              }
            });
          }
          this.setState({ users: users, market: market });
          if (this.state.selectedCompany && this.state.market) {
            this.handleSetVendorUsers(this.state.selectedCompany, this.state.market);
          }
        }
      })
        .catch((error) => {
          this.market_id = null;
        });
    });
  }

  componentDidMount() {
    const { project } = this.props;

    dataModel.companiesDAO.getCompany(this.props.project.company_id,
      {
        recordDescriptor: {
          company: {
            vendor_companies: { additionalFields: ['is_vendor_company'] },
            teams: {},
            additionalFields: ['logo'],
          },
        },
      })
      .then(projectCompany => {
        if (!projectCompany) {
          projectCompany = this.props.project.company;
        }
        const companyList = this.createCompanyList(projectCompany);
        if (companyList.length > 0 && this.state.market) {
          this.handleSetVendorUsers(companyList[0], this.state.market);
        }
        this.setState({
          projectCompany: projectCompany,
          selectedCompany: companyList.length > 0 ? companyList[0] : null,
        });
      });

    if (project && project.market_id) {
      this.handleLoadMarket();
    }
  }

  componentDidUpdate(prevProps) {
    const { project } = this.props;
    if (prevProps.requestClose != this.props.requestClose) {
      this.handleClose();
    }
    if (project && project.market_id && project.market_id != this.market_id) {
      this.handleLoadMarket();
    }
  }

  handleSetVendorUsers(company, market) {
    if (company.id != this.props.currentCompany.id && market) {
      let vendor_users = market.market_vendor_users.filter(
        marketVendorUser => {
          return marketVendorUser.vendor_company_id == company.id;
        }
      );
      vendor_users = vendor_users.map(vendorUser => {
        return vendorUser.vendor_user;
      });
      this.setState({ vendorUsers: vendor_users });
    }
  }

  handleCompanySelection(company) {
    this.handleSetVendorUsers(company, this.state.market);
    this.setState({ selectedCompany: company });
  }

  createCompanyList(projectCompany) {
    let projectCompanies = [];
    if (projectCompany) {
      if ((!this.props.isBuildOwner && this.props.permissions.canAddProjectMembers)
        || (this.props.isBuildOwner &&
          projectCompany.id == this.props.currentUser.companies[0].id)) {
        projectCompanies.push(projectCompany);
      }
      if (projectCompany.vendor_companies) {
        projectCompany.vendor_companies.forEach(vendor => {
          projectCompanies.push(vendor);
        });
      }
    }
    return projectCompanies;
  }

  createSelectedMemberList() {
    let selectedMembers = null;
    if (this.props.projectMembers && this.props.projectMembers.length > 0) {
      selectedMembers = this.props.projectMembers.filter(member => {
        if (member.first_name) {
          member.name = member.first_name + ' ' + member.last_name;
        }
        /*
                if (this.props.isBuildOwner || this.props.permissions.canEditProject) {
                  if (member.companies && member.companies.length && member.companies[0].id == this.props.currentCompany.id) {
                    return true
                  }
                  else {
                    return false
                  }
                }
        */
        return true;
      }, this);

      selectedMembers.sort((u1, u2) => {
        if (u1.name.toLowerCase() < u2.name.toLowerCase()) {
          return -1;
        } else if (u1.name.toLowerCase() > u2.name.toLowerCase()) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return selectedMembers;
  }

  createMemberSelectionList() {
    if (this.state.users) {
      const { projectMembers } = this.props;
      let users = [];
      if (this.state.selectedCompany && this.state.selectedCompany.id == this.props.currentCompany.id) {
        users = this.state.users.map(user => {
          user.company = Object.assign({}, this.props.currentCompany);
          return user;
        });
      }
      else {
        users = this.state.vendorUsers;
      }
      let membersSelectionList = !users ? [] : users.filter(user => {
        let findUser = null;
        if (projectMembers) {
          findUser = projectMembers.find((member) => {
            if (member.first_name || member.last_name) {
              return member.id == user.id;
            }
            else {
              // check the team users...
              return member.users.find((teamUser) => {
                return teamUser.id == user.id;
              });
            }
          });
        }
        if (user.super_admin || findUser) {
          return false;
        }
        else {
          user.name = user.first_name + ' ' + user.last_name;
          return true;
        }
      });
      return membersSelectionList.sort((u1, u2) => {
        return u1.name < u2.name ? -1 : u1.name > u2.name ? 1 : 0;
      });
    }
    return [];
  }

  cancelChange = () => {
    dataModel.systemPopup = null;
  };

  render() {
    let { project } = this.props;
    const { projectCompany } = this.state;
    if (project == undefined) {
      return null;
    }

    const companyList = this.createCompanyList(projectCompany);
    const selectedMembers = this.createSelectedMemberList();
    const membersSelectionList = this.createMemberSelectionList();
 
    return (
      <div className="company-members-main-body">
        <div className="left-side">
          <div className="selection-section company-section">
            <div className="label">{this.textMap.selectCompany}</div>
            <div className="combo-box-container">
           
              <SelectCompanyComboBox
                id={'select-vendor-company-combobox'}
                key={'select-vendor-company-combobox'}
                width={218}
                hasBorder={true}
                noBackground={false}
                handleSelection={this.handleCompanySelection}
                currentSelectedCompany={this.state.selectedCompany}
                adjustHeight={true}
                companies={companyList}
              />
            </div>
          </div>
          <div className="selection-section user-section">
            <div className="label taller">{this.textMap.selectMember}</div>
           
            <SelectMemberList
              members={membersSelectionList}
              type='available'
              selectMember={this.props.handleAddMember}
            />
            {this.state.loadingMarkets && <LoadingDots />}
            <div className="instructions">Click to Add</div>
          </div>
        </div>
        <div className="right-side">
          <div className="selection-section user-section">
            <div className="label">{this.textMap.selectedMember}</div>
            <SelectMemberList
              members={selectedMembers}
              type='project'
              selectMember={this.props.handleRemoveMember}
            />
            <div className="instructions">{'Click to Remove'}</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(CompanyMembers);



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectCRUD/SelectProjectMemberPopup/CompanyMembers/index.js